import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AccessControl from '@gef-ui/cdu-user/components/AccessControl';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { codelistProvider, Dialog } from 'components';
import Panel from 'components/atoms/GefMui/Panel/Panel';
import PaperWithToolbar from 'components/atoms/GefMui/PaperWithToolbar';
import { codelists } from 'constants/codelists';
import MODALS from 'constants/modals';
import PAGES from 'constants/pages';
import { KMP_FUTURE_CAMPAIGN } from 'features/common/acl/constants';
import fetch from 'features/common/fetch';
import { subheaders } from 'features/common/Subheader/constants';
import { resetCampaignDetail } from 'features/views/campaignDashboards/campaignDetail/actions';
import campaigns from 'features/views/campaignDashboards/campaigns';
import {
	currentCampaignActions,
	planedCampaignsActions,
	submitForm,
} from 'features/views/campaignDashboards/campaigns/actions';
import contactFeedback from 'features/views/contactFeedback';

import OrderModal from '../modals/OrderModal';
import CurrentCampaignsTable from './CurrentCampaignsTable';
import Filter from './Filter';
import PlanedCampaignsTable from './PlanedCampaignsTable';
import Toolbar from './Toolbar';

const { urls } = fetch.constants;
const fetchStorePath = `${urls.campaignList}.${campaigns.constants.campaignViews.CURRENT_CAMPAIGNS}`;

const CampaignOverview = () => {
	const dispatch = useDispatch();
	const wasFetched = useSelector(fetch.selectors.getWasFetched(fetchStorePath));

	useEffect(() => {
		dispatch(resetCampaignDetail());
		if (wasFetched) {
			dispatch(currentCampaignActions.reload());
			dispatch(planedCampaignsActions.reload());
		} else {
			// true "initilizingFetch" parameter
			dispatch(submitForm(true));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch]);

	const floatingDialogs = (
		<Dialog name={contactFeedback.constants.dialogs.PARTNER_LOCKED_DIALOG}>
			{getLabelMessage('contactDetail:partnerLocked')}
		</Dialog>
	);

	return (
		<Panel
			screenId={PAGES.campaignOverview.id}
			screenName={PAGES.campaignOverview.name}
			floatingDialogs={floatingDialogs}
		>
			<OrderModal id={MODALS.order} />
			<PaperWithToolbar
				toggledElement={<Filter />}
				toolbar={<Toolbar />}
				collapsibleProps={{ id: subheaders.currentCampaigns }}
			>
				<CurrentCampaignsTable />
			</PaperWithToolbar>
			<AccessControl accessLevel={KMP_FUTURE_CAMPAIGN}>
				<PlanedCampaignsTable />
			</AccessControl>
		</Panel>
	);
};

export default codelistProvider(codelists.campaignChannels, 'campaignChannels')(CampaignOverview);
